document.addEventListener("DOMContentLoaded", function() {
    const questions = document.querySelectorAll(".faq .question");

    for (let i = 0; i < questions.length; i++) {
        questions[i].addEventListener("click", function() {
            const faq = this.parentElement;
            const answer = faq.querySelector(".answer");

            if (faq.classList.contains("active")) {
                faq.classList.remove("active");
                answer.style.height = "0";
            }
            else {
                faq.classList.add("active");
                
                const p = answer.querySelector("p");

                const height = p.offsetHeight + 20;
                answer.style.height = `${height}px`;
            }
        });
    }
});